export const parsForTable = res => {
  let parsData = [];

  if (res.length > 0) {
    parsData = res.map(group => {
      return {
        id: group.id,
        title: group.pressRelease.title,
        createdDate: group.createdDate,
        articleTitle: group.pressRelease.articleTitle,
        articlesLen: group.articlesLen,
        totalAttendance: group.totalAttendance,
        totalAverageAttendance: group.totalAverageAttendance,
        hasNewArticlesAlert: group.hasNewArticlesAlert,
        alertId: group.alertId
      };
    });
  }
  return parsData;
};

export const parsForMaxAttendance = data => {
  const dataSort = [
    ...data.sort((a, b) => b.totalAverageAttendance - a.totalAverageAttendance)
  ];
  return dataSort;
};

export const parsForMaxArticlesLen = data => {
  const dataSort = [...data.sort((a, b) => b.articlesLen - a.articlesLen)];
  return dataSort;
};
